import {EntiteRefTech} from "./EntiteRefTech";

export interface EntiteResponse {
  status: string,
  results: number,
  data: Entite[],
  total: number,
  params: Params
}

export interface EntiteIdResponse {
  status: string,
  results: number,
  data: Entite,
  total: number,
  params: Params
}

export interface Entite {
  id: number
  libelle: string,
  actif: boolean,
  interne: boolean,
  creation_datetime: string,
  referent?: string,
  email?: string,
  telephone?: string,
  update_datetime?: string
  entiteRefTech: EntiteRefTech[]
}

export interface Params {
  page: number;
  limit: number;
  orderBy: string,
  direction: string,
  actif?: string,
  interne?: string
}

export enum InterneExterne {
  Interne = 'Interne',
  Externe = 'Externe'
}
